import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FileUploadState {
  file?: File;
  progress: number;
  uploading: boolean;
}

const initialState: FileUploadState = {
  file: undefined,
  progress: 0,
  uploading: false,
};

const fileUploadSlice = createSlice({
  name: "fileUpload",
  initialState,
  reducers: {
    setFile(state, action: PayloadAction<File | undefined>) {
      state.file = action.payload;
    },
    setProgress(state, action: PayloadAction<number>) {
      state.progress = action.payload;
    },
    setUploading(state, action: PayloadAction<boolean>) {
      state.uploading = action.payload;
    },
    resetUploadState(state) {
      state.file = undefined;
      state.progress = 0;
      state.uploading = false;
    },
  },
});

export const { setFile, setProgress, setUploading, resetUploadState } = fileUploadSlice.actions;
export default fileUploadSlice.reducer;
